
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";
import { Database } from "@/integrations/supabase/types";

type EntryInsert = Database["public"]["Tables"]["entries"]["Insert"];

interface PasswordProtectionCardProps {
  entry: EntryInsert & { is_pinned?: boolean };
  onFieldChange: (field: string, value: any) => void;
}

export const PasswordProtectionCard: React.FC<PasswordProtectionCardProps> = ({
  entry,
  onFieldChange
}) => {
  return (
    <Card>
      <CardContent className="pt-6">
        <h3 className="flex items-center text-lg font-medium mb-4">
          <Lock className="h-4 w-4 mr-2" />
          Password Protection
        </h3>
        <div className="space-y-4">
          <Label htmlFor="password">Password (Optional)</Label>
          <Input
            id="password"
            type="password"
            value={entry.password || ""}
            onChange={(e) => onFieldChange("password", e.target.value)}
            placeholder="Leave blank for no password"
            className="max-w-full"
            maxLength={50}
          />
          <p className="text-sm text-muted-foreground">
            Add a password to protect this entry when shared. When protected:
          </p>
          <ul className="text-sm list-disc list-inside text-muted-foreground">
            <li>Content preview will be hidden on dashboard</li>
            <li>Password entry will be required to view content</li>
          </ul>
        </div>
      </CardContent>
    </Card>
  );
};
